import { Money } from '@mui/icons-material'
import CouponList from './CouponList'
import CouponEdit from './CouponEdit'
import CouponCreate from './CouponCreate'

const couponIndex = {
  list: CouponList,
  edit: CouponEdit,
  create: CouponCreate,
  icon: Money,
}

export default couponIndex
